import React from 'react';
import { ROUTE, SERVER_ACTION } from 'constant';
import { withRouter } from 'react-router-dom';
import Shared from 'screens/shared';
import { service } from 'services';
import { createLink, _t } from 'utils';
import { featuresToggle } from 'utils/features-toggle';
import { actions } from 'redux/actions';

const Tiles = ({ history, match }) => {
  const { dcId, id } = match?.params;

  const consoleClickHandler = async () => {
    const { token = '' } = await service.server.getAccessToken({ dcId, id });
    if (!token) return alert('Something went wrong');
    const url = `https://dcd.ionos.com/console/client/vnc/?token=${token}`;
    return window.open(url, '_blank');
  };

  const items = [
    {
      name: 'Console',
      icon: 'expand',
      onClick: consoleClickHandler,
    },
  ];

  if (featuresToggle.isMonitoring()) {
    items.push({
      name: 'Monitoring',
      icon: 'chart-line',
      onClick: () => {
        history.push(createLink(ROUTE.DASHBOARD.MONITORING_SERVER, { dcId, serverId: id }));
      },
    },
    {
      name: 'Alarms',
      icon: 'bell',
      onClick: () => history.push(ROUTE.DASHBOARD.MONITORING_ALARMS.path),
    });
  }

  items.push({
    renderer: () => (
      <Shared.widgets.PopupMenu
        options={[[SERVER_ACTION.START, _t('Start')], [SERVER_ACTION.STOP, _t('Stop')], [SERVER_ACTION.REBOOT, _t('Reboot')]]}
        onClick={(action) => {
          actions.server.action({ dcId, action, id });
          history.push(createLink(ROUTE.DASHBOARD.DATA_CENTER, { id: dcId }));
        }}
        key="power"
      >
        <div className="tiles-item" style={{ backgroundColor: 'var(--color-base)' }}>
          <Shared.widgets.Icon name="power-off" className="icon" />
          <span className="f-14 w-100p text-center p-t-8">Power</span>
        </div>
      </Shared.widgets.PopupMenu>
    ),
  });

  return (
    <div className="flex flex-wrap">
      <Shared.widgets.Tiles items={items} />
    </div>
  );
};

export default withRouter(Tiles);
